import { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { parseISO, format } from "date-fns";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const dateCellRenderer = (params) => {
  const date = format(parseISO(params.value), "dd/MM/yy HH:mm");
  return date;
};

const dateValueGetter = (params, key) => {
  if (!params.data[key]) {
    return "";
  }
  const date = format(parseISO(params.data[key]), "dd/MM/yy HH:mm");
  return date;
};

const emailCellRenderer = (params) => {
  return <a href={`mailto:${params.data.email}`}>Email</a>;
};

const quoteFileURLCellRenderer = (params) => {
  return (
    <a target="_blank" href={params.data.quoteFileURL}>
      Link
    </a>
  );
};

const columns = [
  {
    field: "configuration.customer.name",
    headerName: "Generated For",
    resizable: true,
  },
  {
    field: "configuration.generatedBy.email",
    headerName: "Generated By",
    resizable: true,
  },
  {
    field: "quoteNo",
    headerName: "Quote Number",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "name",
    headerName: "Name",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "email",
    headerName: "Email",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: emailCellRenderer,
  },
  {
    field: "quoteFileURL",
    headerName: "Quote File URL",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: quoteFileURLCellRenderer,
  },
  {
    field: "tel",
    headerName: "Tel",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "createdAt",
    headerName: "Created On",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: dateCellRenderer,
    filterParams: {
      valueGetter: (params) => {
        return dateValueGetter(params, "createdAt");
      },
    },
  },
  // {
  //   field: "configuration",
  //   headerName: "Configuration",
  //   resizable: true,
  //   filter: "agTextColumnFilter",
  // },
];

function Quotes() {
  const [quotes, setQuotes] = useState([]);

  const getQuotes = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/customer/quotes`
      );
      if (response.status === 200) {
        const quotes = response.data.quotes;
        setQuotes(quotes);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getQuotes(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col xs={{ span: 6 }}>
          <h1 style={{ marginBottom: "30px" }}>Quotes</h1>
        </Col>
      </Row>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            minWidth: 170,
          }}
          floatingFilter={true}
          columnDefs={columns}
          rowData={quotes}
          onGridReady={onGridReady}
          rowHeight={42}
        />
      </div>
    </div>
  );
}
export default Quotes;
